import React, { createContext, useContext, useEffect, useState } from "react";

const STRINGS = {
  en: {
    appName: "GulfBridge",
    tagline: "Arabic ⇄ English, made effortless for the Gulf.",
    heroTitle: "Talk to anyone in the Gulf, in any language.",
    heroSub: "Instantly translate WhatsApp text and voice notes between Arabic and English — with Gulf dialect understanding, smart replies, and a powerful business inbox.",
    getStarted: "Get Started Free",
    login: "Log In",
    logout: "Log out",
    register: "Create Account",
    email: "Email",
    password: "Password",
    name: "Full Name",
    accountType: "Account Type",
    individual: "Individual",
    business: "Business",
    businessName: "Business Name",
    continueGoogle: "Continue with Google",
    or: "or",
    translator: "Translator",
    inbox: "Team Inbox",
    analytics: "Analytics",
    history: "History",
    typeMessage: "Paste or type a message…",
    translateToEn: "Translate to English",
    translateToAr: "Translate to Arabic",
    translate: "Translate",
    original: "Original",
    translation: "Translation",
    suggestedReplies: "Suggested replies",
    playAudio: "Play audio",
    copy: "Copy",
    copied: "Copied!",
    voiceNote: "Voice Note",
    recordOrUpload: "Record or upload a voice note to transcribe & translate",
    record: "Record",
    stop: "Stop",
    upload: "Upload audio",
    transcribing: "Transcribing & translating…",
    noHistory: "No translations yet. Start translating!",
    conversations: "Conversations",
    crm: "Customer",
    notes: "Notes",
    tags: "Tags",
    addTag: "Add tag…",
    saveNotes: "Save",
    reply: "Reply",
    suggest: "Suggest replies",
    sendReply: "Send",
    replyPlaceholder: "Type your reply…",
    detected: "Detected",
    welcome: "Welcome back",
    createAccount: "Create your account",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    customer: "Customer",
    agent: "You",
    selectConversation: "Select a conversation to start",
    totalConversations: "Conversations",
    totalMessages: "Messages",
    totalTranslations: "Text translations",
    voiceTranslations: "Voice translations",
    agentReplies: "Agent replies",
    activityByAgent: "Activity by agent",
    activityByDay: "Activity over time",
    feature1Title: "Voice note translation",
    feature1Desc: "Tap once to transcribe and translate any WhatsApp voice note into clear text — then play it back as audio.",
    feature2Title: "Gulf dialect smart",
    feature2Desc: "Understands Khaleeji slang from UAE, Saudi, Kuwait, Qatar, Bahrain & Oman — not just textbook Arabic.",
    feature3Title: "Business team inbox",
    feature3Desc: "A shared WhatsApp-style inbox with auto language detection, smart replies, CRM notes and customer tags.",
    listenTranslation: "Listen",
    autoDetect: "Auto",
    settings: "Settings",
    plans: "Plans",
    savedReplies: "Saved Replies",
    team: "Team",
    profile: "Profile",
    translationSettings: "Translation",
    whatsapp: "WhatsApp",
    sector: "Business Sector",
    autoTranslateIncoming: "Auto-translate incoming messages",
    autoTranslateHint: "When on, customer messages are translated automatically. When off, agents tap to translate.",
    save: "Save",
    saved: "Saved!",
    inviteAgent: "Invite Agent",
    agentName: "Agent Name",
    addReply: "Add Reply",
    replyLabel: "Label",
    replyText: "Reply text",
    leadStatus: "Lead Status",
    followUp: "Follow-up date",
    appointment: "Appointment",
    appointmentNote: "Appointment note",
    quickReplies: "Quick replies",
    connectWhatsapp: "Connect WhatsApp Business",
    whatsappNumber: "WhatsApp Business Number",
    connected: "Connected",
    notConnected: "Not connected",
    remove: "Remove",
    role: "Role",
    manager: "Manager",
    agent: "Agent",
    onboardingTitle: "Let's set up your business",
    onboardingStep: "Step",
    next: "Next",
    back: "Back",
    finish: "Finish Setup",
    chooseSector: "What's your business sector?",
    setLanguages: "Translation preferences",
    inviteTeam: "Invite your team (optional)",
    skipForNow: "Skip for now",
    statusNew: "New",
    statusQualified: "Qualified",
    statusFollowUp: "Follow-up",
    statusWon: "Won",
    statusLost: "Lost",
    autoTranslated: "Auto-translated",
    pricingTitle: "Simple pricing for every GCC business",
    pricingSub: "Start free. Upgrade as your team and message volume grow.",
    currentPlan: "Current plan",
    choosePlan: "Choose plan",
    perMonth: "/mo",
    convMode: "Conversation",
    translateMode: "Translate",
    convPersonA: "Person A",
    convPersonB: "Person B",
    convSpeaking: "speaking",
    convSwap: "Swap speakers",
    convReset: "Clear",
    convEmpty: "Tap the mic and just speak — Arabic or English. GulfBridge auto-detects the language, translates to the other, and plays it out loud for the other person.",
    convListening: "Listening…",
    convSpeakNow: "Speak now — tap again to translate",
    convTapMic: "Tap the mic to speak",
    convDone: "Done",
    glossary: "Glossary",
    glossaryHint: "Add business terms so translations stay consistent. Import in bulk from CSV or Excel.",
    glossaryEmpty: "No glossary terms yet.",
    glTerm: "Term",
    glTranslation: "Translation",
    glContext: "Context",
    add: "Add",
    bulkImport: "Import CSV/Excel",
    bulkImportHint: "Columns: term, translation, context",
    languageRouting: "Language-based lead routing",
    languageRoutingHint: "Auto-assign conversations to agents who speak the customer's language.",
    proficientLanguages: "Languages spoken",
    contactLanguage: "Contact language",
    langAuto: "Auto",
    aiDrafts: "AI drafts",
    businessIntelligence: "Business Intelligence",
    biTopPhrases: "Top translated phrases",
    biDirections: "Translation direction",
    biHeatmap: "Volume by day & hour",
    biPerAgent: "Per-agent performance",
    biReplies: "Replies",
    biAvgResponse: "Avg. response",
    biTotalTranslations: "Total translations",
    biNoData: "Not enough data yet. Insights appear as your team translates and replies.",
    biNoPhrases: "No translated phrases yet.",
    biMinShort: "min",
    learning: "Learning",
    learnOverview: "Overview",
    myPhrases: "My Phrases",
    contentPacks: "Content Packs",
    phrasesLearned: "Phrases learned",
    phrasesSaved: "Saved",
    phrasesMastered: "Mastered",
    recentlyLearned: "Recently learned",
    topPhrasesWeek: "Your top phrases this week",
    teamLeaderboard: "Team leaderboard",
    noPhrasesYet: "Translate messages in the inbox or translator to start building your phrasebook.",
    practiceThis: "Practice",
    saveToMyPhrases: "Save",
    savedLabel: "Saved",
    learnPopupTitle: "New phrase learned",
    listenLabel: "Listen",
    contextLabel: "Context",
    pronunciationLabel: "Pronunciation",
    practiceTitle: "Practice pronunciation",
    practiceIntro: "Listen, then record yourself saying the phrase in Arabic.",
    recordPronunciation: "Record",
    yourScore: "Your score",
    weHeard: "We heard",
    tryAgain: "Try again",
    greatJob: "Great — that sounds accurate!",
    keepPracticing: "Close — keep practicing.",
    masteredBadge: "Mastered",
    subscribeLabel: "Subscribe",
    subscribedLabel: "Subscribed",
    requireForTeam: "Require for team",
    requiredForTeam: "Required",
    packsLockedTitle: "Content Packs are a Pro feature",
    packsLockedBody: "Upgrade to Pro or Business to give your team curated industry phrase packs.",
    upgradeNow: "Upgrade",
    phrasesCount: "phrases",
    diffBeginner: "Beginner",
    diffIntermediate: "Intermediate",
    diffAdvanced: "Advanced",
    learningFeatures: "Learning",
    enableLearning: "Learn-as-you-translate",
    enableLearningHint: "Log translated phrases and show micro-learning tips to agents.",
    enableContentPacks: "Content packs",
    enableContentPacksHint: "Let agents subscribe to curated business Arabic phrase packs.",
    planLabel: "Current plan",
    planUpdated: "Plan updated",
    proOnly: "Pro",
    dismiss: "Dismiss",
    learnMore: "View in Learning",
    quiz: "Quiz",
    dailyQuiz: "Daily Quiz",
    startQuiz: "Start daily quiz",
    quizReady: "Quiz ready",
    quizQuestionOf: "Question",
    quizCorrect: "Correct!",
    quizWrong: "Not quite",
    quizCorrectAnswer: "Answer",
    quizComplete: "Quiz complete",
    quizYouScored: "You scored",
    quizNext: "Next",
    quizEmpty: "Learn a few phrases first, then come back for your daily quiz.",
    quizDone: "Done",
    rolePlay: "Role-play",
    chooseScenario: "Choose a scenario",
    rolePlayIntro: "Practice a real customer chat — the AI plays a GCC customer. Reply in Arabic or English.",
    startSession: "Start",
    typeReply: "Type your reply…",
    finishScore: "Finish & score",
    scorecard: "Scorecard",
    clarity: "Clarity",
    politeness: "Politeness",
    completeness: "Completeness",
    newScenario: "New scenario",
    customerLabel: "Customer",
    youLabel: "You",
    streakLabel: "Day streak",
    badgeTitle: "Arabic Achiever",
    badgeMasteredLabel: "phrases mastered",
    shareBadge: "Share",
    shareCopied: "Copied — paste it anywhere!",
    digestTitle: "Your week in review",
    digestBody: "You practiced {n} phrases this week. Keep your streak alive!",
    proFeature: "Pro",
  },
  ar: {
    appName: "جسر الخليج",
    tagline: "العربية ⇄ الإنجليزية، بكل سهولة لأهل الخليج.",
    heroTitle: "تواصل مع أي شخص في الخليج، بأي لغة.",
    heroSub: "ترجمة فورية لرسائل واتساب النصية والصوتية بين العربية والإنجليزية — مع فهم اللهجة الخليجية، وردود ذكية، وصندوق وارد قوي للأعمال.",
    getStarted: "ابدأ مجاناً",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    register: "إنشاء حساب",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    accountType: "نوع الحساب",
    individual: "فردي",
    business: "أعمال",
    businessName: "اسم النشاط التجاري",
    continueGoogle: "المتابعة عبر جوجل",
    or: "أو",
    translator: "المترجم",
    inbox: "صندوق الفريق",
    analytics: "التحليلات",
    history: "السجل",
    typeMessage: "الصق أو اكتب رسالة…",
    translateToEn: "ترجم إلى الإنجليزية",
    translateToAr: "ترجم إلى العربية",
    translate: "ترجم",
    original: "النص الأصلي",
    translation: "الترجمة",
    suggestedReplies: "ردود مقترحة",
    playAudio: "تشغيل الصوت",
    copy: "نسخ",
    copied: "تم النسخ!",
    voiceNote: "رسالة صوتية",
    recordOrUpload: "سجّل أو ارفع رسالة صوتية لتحويلها وترجمتها",
    record: "تسجيل",
    stop: "إيقاف",
    upload: "رفع ملف صوتي",
    transcribing: "جارٍ التحويل والترجمة…",
    noHistory: "لا توجد ترجمات بعد. ابدأ الترجمة!",
    conversations: "المحادثات",
    crm: "العميل",
    notes: "ملاحظات",
    tags: "الوسوم",
    addTag: "أضف وسماً…",
    saveNotes: "حفظ",
    reply: "رد",
    suggest: "اقترح ردوداً",
    sendReply: "إرسال",
    replyPlaceholder: "اكتب ردك…",
    detected: "تم الكشف",
    welcome: "مرحباً بعودتك",
    createAccount: "أنشئ حسابك",
    haveAccount: "لديك حساب بالفعل؟",
    noAccount: "ليس لديك حساب؟",
    customer: "العميل",
    agent: "أنت",
    selectConversation: "اختر محادثة للبدء",
    totalConversations: "المحادثات",
    totalMessages: "الرسائل",
    totalTranslations: "ترجمات نصية",
    voiceTranslations: "ترجمات صوتية",
    agentReplies: "ردود الوكلاء",
    activityByAgent: "النشاط حسب الوكيل",
    activityByDay: "النشاط عبر الوقت",
    feature1Title: "ترجمة الرسائل الصوتية",
    feature1Desc: "بضغطة واحدة، حوّل أي رسالة صوتية في واتساب إلى نص واضح وترجمها — ثم استمع إليها صوتياً.",
    feature2Title: "ذكاء اللهجة الخليجية",
    feature2Desc: "يفهم اللهجة الخليجية من الإمارات والسعودية والكويت وقطر والبحرين وعُمان — وليس العربية الفصحى فقط.",
    feature3Title: "صندوق وارد للفرق",
    feature3Desc: "صندوق وارد مشترك بأسلوب واتساب مع كشف تلقائي للغة، وردود ذكية، وملاحظات ووسوم للعملاء.",
    listenTranslation: "استمع",
    autoDetect: "تلقائي",
    settings: "الإعدادات",
    plans: "الباقات",
    savedReplies: "الردود المحفوظة",
    team: "الفريق",
    profile: "الملف التعريفي",
    translationSettings: "الترجمة",
    whatsapp: "واتساب",
    sector: "قطاع العمل",
    autoTranslateIncoming: "ترجمة الرسائل الواردة تلقائياً",
    autoTranslateHint: "عند التفعيل، تُترجم رسائل العملاء تلقائياً. عند الإيقاف، يضغط الوكيل للترجمة.",
    save: "حفظ",
    saved: "تم الحفظ!",
    inviteAgent: "دعوة وكيل",
    agentName: "اسم الوكيل",
    addReply: "إضافة رد",
    replyLabel: "التسمية",
    replyText: "نص الرد",
    leadStatus: "حالة العميل المحتمل",
    followUp: "تاريخ المتابعة",
    appointment: "الموعد",
    appointmentNote: "ملاحظة الموعد",
    quickReplies: "ردود سريعة",
    connectWhatsapp: "ربط واتساب للأعمال",
    whatsappNumber: "رقم واتساب للأعمال",
    connected: "متصل",
    notConnected: "غير متصل",
    remove: "إزالة",
    role: "الدور",
    manager: "مدير",
    agent: "وكيل",
    onboardingTitle: "لنُجهّز نشاطك التجاري",
    onboardingStep: "الخطوة",
    next: "التالي",
    back: "السابق",
    finish: "إنهاء الإعداد",
    chooseSector: "ما هو قطاع عملك؟",
    setLanguages: "تفضيلات الترجمة",
    inviteTeam: "ادعُ فريقك (اختياري)",
    skipForNow: "تخطٍّ الآن",
    statusNew: "جديد",
    statusQualified: "مؤهل",
    statusFollowUp: "متابعة",
    statusWon: "تم الكسب",
    statusLost: "خسارة",
    autoTranslated: "تُرجم تلقائياً",
    pricingTitle: "أسعار بسيطة لكل نشاط تجاري في الخليج",
    pricingSub: "ابدأ مجاناً. ارتقِ مع نمو فريقك وحجم رسائلك.",
    currentPlan: "الباقة الحالية",
    choosePlan: "اختر الباقة",
    perMonth: "/شهرياً",
    convMode: "محادثة",
    translateMode: "ترجمة",
    convPersonA: "الشخص أ",
    convPersonB: "الشخص ب",
    convSpeaking: "يتحدّث",
    convSwap: "تبديل المتحدثين",
    convReset: "مسح",
    convEmpty: "اضغط الميكروفون وتحدّث فحسب — بالعربية أو الإنجليزية. يكتشف جسر الخليج اللغة تلقائياً، يترجمها إلى الأخرى، وينطقها بصوتٍ مسموع للطرف الآخر.",
    convListening: "جارٍ الاستماع…",
    convSpeakNow: "تحدّث الآن — اضغط مرة أخرى للترجمة",
    convTapMic: "اضغط الميكروفون للتحدّث",
    convDone: "تم",
    glossary: "المصطلحات",
    glossaryHint: "أضف مصطلحات عملك لتبقى الترجمات متسقة. يمكنك الاستيراد دفعةً واحدة من CSV أو Excel.",
    glossaryEmpty: "لا توجد مصطلحات بعد.",
    glTerm: "المصطلح",
    glTranslation: "الترجمة",
    glContext: "السياق",
    add: "إضافة",
    bulkImport: "استيراد CSV/Excel",
    bulkImportHint: "الأعمدة: المصطلح، الترجمة، السياق",
    languageRouting: "توجيه العملاء حسب اللغة",
    languageRoutingHint: "إسناد المحادثات تلقائياً إلى الوكلاء الذين يتحدثون لغة العميل.",
    proficientLanguages: "اللغات",
    contactLanguage: "لغة جهة الاتصال",
    langAuto: "تلقائي",
    aiDrafts: "مسودات ذكية",
    businessIntelligence: "ذكاء الأعمال",
    biTopPhrases: "أكثر العبارات ترجمةً",
    biDirections: "اتجاه الترجمة",
    biHeatmap: "الحجم حسب اليوم والساعة",
    biPerAgent: "أداء كل وكيل",
    biReplies: "الردود",
    biAvgResponse: "متوسط الرد",
    biTotalTranslations: "إجمالي الترجمات",
    biNoData: "لا توجد بيانات كافية بعد. تظهر الرؤى مع ترجمة الفريق وردوده.",
    biNoPhrases: "لا توجد عبارات مُترجمة بعد.",
    biMinShort: "دقيقة",
    learning: "التعلّم",
    learnOverview: "نظرة عامة",
    myPhrases: "عباراتي",
    contentPacks: "حزم المحتوى",
    phrasesLearned: "عبارات تعلّمتها",
    phrasesSaved: "محفوظة",
    phrasesMastered: "متقنة",
    recentlyLearned: "تعلّمتها مؤخراً",
    topPhrasesWeek: "أكثر عباراتك هذا الأسبوع",
    teamLeaderboard: "لوحة صدارة الفريق",
    noPhrasesYet: "ترجم الرسائل في صندوق الوارد أو المترجم لتبدأ ببناء دفتر عباراتك.",
    practiceThis: "تدرّب",
    saveToMyPhrases: "حفظ",
    savedLabel: "محفوظة",
    learnPopupTitle: "عبارة جديدة تعلّمتها",
    listenLabel: "استمع",
    contextLabel: "السياق",
    pronunciationLabel: "النطق",
    practiceTitle: "تدرّب على النطق",
    practiceIntro: "استمع، ثم سجّل نفسك وأنت تنطق العبارة بالعربية.",
    recordPronunciation: "تسجيل",
    yourScore: "نتيجتك",
    weHeard: "سمعنا",
    tryAgain: "حاول مجدداً",
    greatJob: "رائع — النطق دقيق!",
    keepPracticing: "قريب — واصل التدرّب.",
    masteredBadge: "متقنة",
    subscribeLabel: "اشترك",
    subscribedLabel: "مشترك",
    requireForTeam: "إلزامي للفريق",
    requiredForTeam: "إلزامي",
    packsLockedTitle: "حزم المحتوى ميزة Pro",
    packsLockedBody: "قم بالترقية إلى Pro أو Business لتزويد فريقك بحزم عبارات عربية متخصصة.",
    upgradeNow: "ترقية",
    phrasesCount: "عبارة",
    diffBeginner: "مبتدئ",
    diffIntermediate: "متوسط",
    diffAdvanced: "متقدم",
    learningFeatures: "التعلّم",
    enableLearning: "التعلّم أثناء الترجمة",
    enableLearningHint: "تسجيل العبارات المترجمة وعرض نصائح تعلّم للوكلاء.",
    enableContentPacks: "حزم المحتوى",
    enableContentPacksHint: "السماح للوكلاء بالاشتراك في حزم عبارات عربية للأعمال.",
    planLabel: "الخطة الحالية",
    planUpdated: "تم تحديث الخطة",
    proOnly: "Pro",
    dismiss: "إغلاق",
    learnMore: "عرض في التعلّم",
    quiz: "اختبار",
    dailyQuiz: "الاختبار اليومي",
    startQuiz: "ابدأ الاختبار اليومي",
    quizReady: "الاختبار جاهز",
    quizQuestionOf: "سؤال",
    quizCorrect: "إجابة صحيحة!",
    quizWrong: "ليست صحيحة",
    quizCorrectAnswer: "الإجابة",
    quizComplete: "اكتمل الاختبار",
    quizYouScored: "نتيجتك",
    quizNext: "التالي",
    quizEmpty: "تعلّم بعض العبارات أولاً ثم عد لاختبارك اليومي.",
    quizDone: "تم",
    rolePlay: "محادثة تدريبية",
    chooseScenario: "اختر سيناريو",
    rolePlayIntro: "تدرّب على محادثة عميل حقيقية — الذكاء الاصطناعي يلعب دور عميل خليجي. رُدّ بالعربية أو الإنجليزية.",
    startSession: "ابدأ",
    typeReply: "اكتب ردّك…",
    finishScore: "إنهاء وتقييم",
    scorecard: "بطاقة النتيجة",
    clarity: "الوضوح",
    politeness: "اللباقة",
    completeness: "الاكتمال",
    newScenario: "سيناريو جديد",
    customerLabel: "العميل",
    youLabel: "أنت",
    streakLabel: "أيام متتالية",
    badgeTitle: "متميّز بالعربية",
    badgeMasteredLabel: "عبارة متقنة",
    shareBadge: "مشاركة",
    shareCopied: "تم النسخ — الصقه في أي مكان!",
    digestTitle: "ملخّص أسبوعك",
    digestBody: "تدرّبت على {n} عبارة هذا الأسبوع. حافظ على تتابعك!",
    proFeature: "Pro",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("gb_lang") || "en");

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("gb_lang", lang);
  }, [lang]);

  const t = (key) => STRINGS[lang][key] ?? STRINGS.en[key] ?? key;
  const toggle = () => setLang((l) => (l === "en" ? "ar" : "en"));

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t, dir: lang === "ar" ? "rtl" : "ltr" }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
